module.exports = __webpack_public_path__ + "img/curated_msg.30ae4257.png";